module.exports = __webpack_public_path__ + "img/icon-siwei-logo.c6a8cd08.png";